var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUserDetailsClose = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 3,
    fill: "#F4F5F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_870_1750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5799 24.65L31.6599 20.57C32.4799 19.75 32.4799 18.43 31.6599 17.62C30.8399 16.81 29.5199 16.8 28.7099 17.62L24.6299 21.7L20.5599 17.62C19.7499 16.81 18.4299 16.81 17.6099 17.62C16.7999 18.44 16.7999 19.76 17.6099 20.58L21.6799 24.65L17.6399 28.69C16.8199 29.51 16.8199 30.83 17.6399 31.64C18.4599 32.46 19.7799 32.46 20.5899 31.64L24.6299 27.6L28.6799 31.65C29.4999 32.47 30.8199 32.47 31.6299 31.65C32.4399 30.83 32.4499 29.51 31.6299 28.7L27.5799 24.65Z",
    fill: "#323A45"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_870_1750"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.27,
    height: 15.27,
    fill: "white",
    transform: "translate(17 17)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUserDetailsClose);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/user-details-close.70ebe7995722d25b93ae95fb79ccd0fc.svg";